export const AVAILABLE_LAYOUTS: string[] = [
  '60_abnt2',
  '60_ansi',
  '60_ansi_arrow',
  '60_ansi_wkl',
  '60_hhkb',
  '60_iso',
  '60_iso_arrow',
  '60_iso_wkl',
  '60_jis',
  '64_ansi',
  '64_iso',
  '65_ansi',
  '65_iso',
  '66_ansi',
  '66_iso',
  '68_ansi',
  '68_iso',
  '75_ansi',
  '75_iso',
  '96_ansi',
  '96_iso',
  'alice',
  'ergodox',
  'fullsize_ansi',
  'fullsize_extended_ansi',
  'fullsize_extended_iso',
  'fullsize_extended_jis',
  'fullsize_iso',
  'fullsize_jis',
  'numpad_4x4',
  'numpad_5x4',
  'numpad_5x6',
  'numpad_6x4',
  'numpad_6x5',
  'ortho_1x1',
  'ortho_2x3',
  'ortho_2x6',
  'ortho_3x10',
  'ortho_3x3',
  'ortho_4x10',
  'ortho_4x12',
  'ortho_4x16',
  'ortho_4x4',
  'ortho_4x6',
  'ortho_5x10',
  'ortho_5x12',
  'ortho_5x13',
  'ortho_5x14',
  'ortho_5x15',
  'ortho_5x4',
  'ortho_5x5',
  'ortho_6x13',
  'ortho_6x4',
  'planck_mit',
  'split_3x5_2',
  'split_3x5_3',
  'split_3x6_3',
  'tkl_ansi',
  'tkl_ansi_wkl',
  'tkl_iso',
  'tkl_iso_wkl',
  'tkl_jis',
  'tkl_nofrow_ansi',
  'tkl_nofrow_iso',
];

export const DEFAULT_LAYOUT = 'split_3x6_3';
